import { render, staticRenderFns } from "./ClientChildrenList.vue?vue&type=template&id=3b50c524&"
import script from "./ClientChildrenList.vue?vue&type=script&lang=ts&"
export * from "./ClientChildrenList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports